import React, {useMemo, useState} from 'react';
import Button from "@material-ui/core/Button";
import css from './Directions.module.css';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {hideMarker} from "../../store/markerSlice";

const fetchDirections = (oLatLng, dLat, dLng, cb) => {
	if( !oLatLng )
		return;

	console.log("Fetching directions...");
	const directionsService = new window.maps.DirectionsService();
	const request = {
		origin: new window.maps.LatLng(oLatLng[0], oLatLng[1]),
		destination: new window.maps.LatLng(dLat, dLng),
		travelMode: window.maps.DirectionsTravelMode['DRIVING']
	};

	if (window.polylines) {
		window.polylines.setMap(null);
		window.polylines = null;
	}

	try {
		directionsService.route(request, function (response, status) {
			if (status !== 'OK') {
				console.log("ERR: Couldn't get directions: ", response, status);
				return;
			}

			window.polylines = new window.maps.Polyline({
				'path': response.routes[0].overview_path
			});

			window.polylines.setMap(window.map);

			const directionsPoint = response.routes[0].legs[0];
			const results = {miles: directionsPoint.distance.text, minutes: directionsPoint.duration.text};
			cb(results);
		});
	} catch (err) {
		console.log("ERR in directions service:", err);
	}
};


const Directions = (props) => {
	const [directions, setDirections] = useState(null);

	// If we don't useMemo, it'll re-render every time the gps updates, which can be often. This only re-renders when the destination changes
	useMemo(
		() => fetchDirections(props.gpsLocation, props.latitude, props.longitude, setDirections), // eslint-disable-next-line
		[props.latitude, props.longitude]
	);

	const onClickDirections = () => {
		window.location.href = 'http://maps.google.com/?&daddr=' + props.latitude + "," + props.longitude;
	};

	return (<>
		{!!props.gpsLocation && !!directions && <div>
			{directions.miles} ({directions.minutes} by car)
		</div>}


		<div className={css.Buttons}>
			<Button className={css.Button} size='small' color='primary' onClick={onClickDirections} variant='contained'>Directions</Button>
			<Button className={css.Button} size='small' color='primary' onClick={() => props.hideMarker(props.id)} variant='contained'>Hide</Button>
		</div>

	</>);
};

Directions.propTypes = {
	latitude: PropTypes.number.isRequired,
	longitude: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
	return {
		gpsLocation: state.core.gpsLocation,
		discordUser: state.core.discordUser,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		hideMarker: (id) => dispatch(hideMarker(id))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Directions);